import React from "react";
import { InfoIcon } from "../../../../helper/HwIcon";

const bannerStyle = {
    margin: "0 0 16px",
    padding: "12px 14px",
    display: "flex",
    alignItems: "start",
    gap: "8px",
    background: "#eef3ff",
    border: "1px solid #d6e2ff",
    borderRadius: "8px",
};

const VendorInfoBanners = ({
    queryParams,
    airArabiaBundleMessage,
    currentTab,
}) => {
    const source = queryParams?.source;

    if (currentTab?.["2"]?.active || currentTab?.["3"]?.active) {
        return null;
    }

    const isAirArabia =
        source === "air-arabia" && airArabiaBundleMessage;

    const isTravelFusion = source === "travel-fusion";

    if (!isAirArabia && !isTravelFusion) return null;

    return (
        <div
            className="hw-alert hw-alert--info hw-mb-3"
            style={bannerStyle}
        >
            <span className="hw-primary">
                <InfoIcon />
            </span>

            <span className="hw-text14 hw-primary hw-fontWeight--500">
                {isAirArabia ? (
                    "This bundle includes baggage, seat, and meal. Select your included options before continuing."
                ) : (
                    <>
                        Please select a check-in baggage option from the baggage section below.{" "}
                        <br />
                        otherwise, you won’t be allowed to carry check-in baggage
                    </>
                )}
            </span>
        </div>
    );
};

export default React.memo(VendorInfoBanners);